import { render, staticRenderFns } from "./DeskToday.vue?vue&type=template&id=524caf4c&scoped=true&"
var script = {}
import style0 from "./DeskToday.vue?vue&type=style&index=0&id=524caf4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524caf4c",
  null
  
)

export default component.exports